import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'

const CheckDeudores = ({ deudoresCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = deudoresCheck?.checkDetails
  const hasChecks = Array.isArray(details) && details.length > 0
  const checkLength = hasChecks ? details.detail?.entidades?.length : 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:deudores')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} />
      </Paper>

      <CheckDetailTitle
        email={deudoresCheck?.email}
        status={deudoresCheck?.status}
        createdAt={deudoresCheck?.createdAt}
        updatedAt={deudoresCheck?.updatedAt}
      />

      {hasChecks ? (
        details.map((detail, index) => (
          <TimelineDotLine key={index}>
            <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Período</Typography>
                <Typography variant="subtitle3">{detail.periodo || '---'}</Typography>
              </div>

              {detail.entidades?.length > 0 &&
                detail.entidades.map((entidad, i) => (
                  <Paper
                    key={i}
                    elevation={0}
                    sx={{
                      border: '1px solid',
                      borderColor: 'grey.200',
                      borderRadius: '8px',
                      p: 2,
                      mt: 2,
                      backgroundColor: 'grey.50',
                    }}
                  >
                    <div className="c-detail-grid">
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Entidad</Typography>
                        <Typography variant="subtitle3">{entidad.entidad || '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Situación</Typography>
                        <Typography variant="subtitle3">{entidad.situacion || '---'}</Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Fecha Situación</Typography>
                        <Typography variant="subtitle3">
                          {entidad.fechaSit1 ? new Date(entidad.fechaSit1).toLocaleDateString() : '---'}
                        </Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Monto</Typography>
                        <Typography variant="subtitle3">
                          {entidad.monto ? `$${entidad.monto.toLocaleString()}` : '---'}
                        </Typography>
                      </div>
                      <div className="c-detail-row">
                        <Typography variant="subtitle1">Días de atraso</Typography>
                        <Typography variant="subtitle3">{entidad.diasAtrasoPago || '---'}</Typography>
                      </div>
                    </div>
                  </Paper>
                ))}
            </Paper>
          </TimelineDotLine>
        ))
      ) : (
        <Paper elevation={0} sx={{ flex: 1, mt: 2 }}>
          <Typography variant="subtitle3">
            {deudoresCheck?.checkDetails?.info ?? t('messages:noDataCheckAvailable')}
          </Typography>
        </Paper>
      )}
    </>
  )
}

export default CheckDeudores

/* import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './components/CheckDetailTitle'

const variantByLevel = {
  0: 'h3',
  1: 'h4',
}

const CheckDeudores = ({ title = '', deudoresCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = deudoresCheck?.checkDetails

  return (
    <Box className="detail-group" sx={{ padding: '2rem' }}>
      <Typography variant={variantByLevel[level] || variantByLevel[0]} sx={{ marginBottom: '1.5rem' }}>
        {title || t('common:deudores')}
      </Typography>

      <CheckDetailTitle
        email={deudoresCheck?.email}
        status={deudoresCheck?.status}
        createdAt={deudoresCheck?.createdAt}
        updatedAt={deudoresCheck?.updatedAt}
      />

      <Typography variant="h4" sx={{ fontSize: '1.25rem', marginBottom: '1rem' }}>
        Resultados
      </Typography>

      {details && details.length > 0 ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '2rem',
          }}
        >
          {details.map((detail, index) => (
            <Box
              key={index}
              sx={{
                padding: '1.5rem',
                border: '0.1rem solid',
                borderColor: 'grey.300',
                borderRadius: '0.8rem',
                backgroundColor: 'grey.50',
              }}
            >
              <Typography variant="body1" sx={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
                <strong>Período:</strong> {detail.periodo || '---'}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '1rem',
                }}
              >
                {detail.entidades?.length > 0 &&
                  detail.entidades.map((entidad, entidadIndex) => (
                    <Box
                      key={entidadIndex}
                      sx={{
                        padding: '1rem',
                        border: '0.1rem solid',
                        borderColor: 'grey.400',
                        borderRadius: '0.5rem',
                        minWidth: '20rem',
                        flex: '1',
                        backgroundColor: 'grey.100',
                      }}
                    >
                      <Typography variant="body2" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                        <strong>Entidad:</strong> {entidad.entidad || '---'}
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                        <strong>Situación:</strong> {entidad.situacion || '---'}
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                        <strong>Fecha Situación:</strong>{' '}
                        {entidad.fechaSit1 ? new Date(entidad.fechaSit1).toLocaleDateString() : '---'}
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                        <strong>Monto:</strong> ${entidad.monto ? entidad.monto.toLocaleString() : '---'}
                      </Typography>
                      <Typography variant="body2" sx={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
                        <strong>Días de atraso:</strong> {entidad.diasAtrasoPago || '---'}
                      </Typography>
                    </Box>
                  ))}
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        <Typography variant="body1" sx={{ fontSize: '1rem' }}>
          {deudoresCheck?.checkDetails?.info}
        </Typography>
      )}
    </Box>
  )
}

export default CheckDeudores
 */
